export const LABEL_PALETTE = [
  'bg-rose-50 text-rose-700 border-rose-200',
  'bg-orange-50 text-orange-700 border-orange-200',
  'bg-amber-50 text-amber-800 border-amber-200',
  'bg-lime-50 text-lime-700 border-lime-200',
  'bg-emerald-50 text-emerald-700 border-emerald-200',
  'bg-teal-50 text-teal-700 border-teal-200',
  'bg-sky-50 text-sky-700 border-sky-200',
  'bg-indigo-50 text-indigo-700 border-indigo-200',
  'bg-violet-50 text-violet-700 border-violet-200',
  'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200',
  'bg-pink-50 text-pink-700 border-pink-200',
];

export function labelColor(label) {
  let h = 0;
  for (let i = 0; i < label.length; i += 1) {
    h = (h * 31 + label.charCodeAt(i)) >>> 0;
  }
  return LABEL_PALETTE[h % LABEL_PALETTE.length];
}
